// src/middlewares/helpers/auto-instrumentation.helpers.ts
function isObject(variable) {
  return typeof variable === "object" && variable !== null;
}
var isHttpError = (status) => {
  return status >= 400;
};
function isHttpErrorResponse(error) {
  return isObject(error) && "error" in error && "error_parameters" in error;
}
function getUrlFromFetch(fetchArg) {
  if (typeof fetchArg === "string") {
    return fetchArg;
  } else if (fetchArg instanceof URL) {
    return fetchArg.href;
  }
  return fetchArg.url;
}
var getCriticity = (status) => {
  return status && [502, 503, 504].includes(status) ? "INDISPO" : "FATALE";
};
var getBodyFromXhrSend = (data) => {
  if (data === null || data === void 0) {
    return {};
  }
  if (typeof data === "string") {
    try {
      return JSON.parse(data);
    } catch (error) {
      console.error("Invalid JSON string", data);
      return {};
    }
  }
  if (data instanceof FormData) {
    const result = {};
    data.forEach((value, key) => {
      result[key] = value;
    });
    return result;
  }
  if (data instanceof URLSearchParams) {
    const result = {};
    data.forEach((value, key) => {
      result[key] = value;
    });
    return result;
  }
  return { error: "Unhandled data" };
};
var isGraphqlRequest = (reqBody) => {
  return Boolean(reqBody && (reqBody.query || reqBody.mutation));
};
var merge = (messages) => {
  return "[" + messages.join(",") + "]";
};
var isGraphqlError = (reqBody, response) => {
  return isGraphqlRequest(reqBody) && "errors" in response;
};
var buildGraphqlError = (errors) => {
  const errorsNonNull = errors?.filter((e) => e != null);
  if (!errorsNonNull || errorsNonNull.length == 0) {
    return void 0;
  }
  const erreurs = errorsNonNull.map((error) => {
    const graphQLErreur = error;
    const cheminErreur = graphQLErreur?.path && `@ (${graphQLErreur.path.join("\u279D")})`;
    const erreur = {
      code: error.name || graphQLErreur.extensions?.classification,
      description: `${error.message} ${cheminErreur}`,
      type: "TECHNIQUE",
      declencheur: error.stack,
      origine: error.stack?.split(/\n/)[0]
    };
    return erreur;
  });
  return {
    code: merge(erreurs.map((e) => e.code)),
    description: merge(erreurs.map((e) => e.description)),
    type: "TECHNIQUE",
    declencheur: merge(erreurs.map((e) => e.declencheur)),
    origine: merge(erreurs.map((e) => e.origine))
  };
};
var buildHttpError = (error, status) => {
  if (status < 400) {
    return;
  }
  let parametersList = [];
  let description = "";
  try {
    description = error.error_description ?? error.message ?? JSON.stringify(error);
  } catch {
    console.warn({ error });
    description = "unknown type of error";
  }
  let code = "ERREUR_APPEL_RESS";
  try {
    code = error.error ?? error.name ?? code;
  } catch {
    console.warn("UNKNOWN_ERROR_TYPE", { error });
  }
  if (isHttpErrorResponse(error)) {
    try {
      if (typeof error.error_parameters === "string") {
        parametersList = [error.error_parameters];
      } else if (Array.isArray(error.error_parameters)) {
        parametersList = error.error_parameters;
      } else {
        parametersList = [JSON.stringify(error.error_parameters)];
      }
    } catch (error2) {
      console.error("Error while parsing error parameters", error2);
    }
  }
  const type = status >= 500 ? "TECHNIQUE" : "FONCTIONNELLE";
  const criticite = getCriticity(status);
  return {
    code,
    parametres: parametersList,
    type,
    description,
    criticite
  };
};
var isServerAction = (url, acceptHeader) => {
  return !url.match("rsc=") && acceptHeader === "text/x-component";
};
function getFetchMethod(fetchArgs, init) {
  if (fetchArgs instanceof Request) {
    return fetchArgs.method;
  }
  if (init && init.method) {
    return init.method;
  }
  return "GET";
}
var getFetchBody = async (requestInfo, init) => {
  if (init?.body) {
    if (typeof init.body === "string") {
      try {
        return JSON.parse(init.body);
      } catch {
        return {};
      }
    }
    if (init.body instanceof FormData) {
      const result = {};
      init.body.forEach((value, key) => {
        result[key] = value;
      });
      return result;
    }
    if (init.body instanceof URLSearchParams) {
      const result = {};
      init.body.forEach((value, key) => {
        result[key] = value;
      });
      return result;
    }
    console.warn("Unhandled body type in request");
    return { error: `Unhandled body type ${typeof init.body}` };
  }
  if (requestInfo instanceof Request && requestInfo.bodyUsed) {
    return { error: "Unhandled body type (Request)" };
  }
  return {};
};
function getHeadersFromFetch(fetchArgs, init) {
  const headers = {};
  if (fetchArgs instanceof Request) {
    fetchArgs.headers.forEach((value, key) => {
      headers[key] = value;
    });
  }
  if (init?.headers) {
    const initHeaders = new Headers(init.headers);
    initHeaders.forEach((value, key) => {
      headers[key] = value;
    });
  }
  return headers;
}
function addHeadersToFetchRequest(fetchArgs, init, dynamicHeaders = {}) {
  const existingHeaders = getHeadersFromFetch(fetchArgs, init);
  if (!init) {
    init = {};
  }
  init.headers = {
    ...existingHeaders,
    ...dynamicHeaders
  };
  return init;
}
var getXhrResponseHeaders = (xhr) => {
  const rawHeaders = xhr.getAllResponseHeaders().trim().split(/[\r\n]+/);
  const headerMap = {};
  rawHeaders.filter((h) => h).map(function(line) {
    const parts = line.split(": ");
    const header = parts.shift();
    const value = parts.join(": ");
    headerMap[header] = value;
  });
  return headerMap;
};
var getUrlFromXhr = (url) => {
  if (typeof url === "string") {
    return url;
  }
  return url.href;
};

export { addHeadersToFetchRequest, buildGraphqlError, buildHttpError, getBodyFromXhrSend, getCriticity, getFetchBody, getFetchMethod, getHeadersFromFetch, getUrlFromFetch, getUrlFromXhr, getXhrResponseHeaders, isGraphqlError, isGraphqlRequest, isHttpError, isHttpErrorResponse, isObject, isServerAction, merge };
//# sourceMappingURL=chunk-RDMEGTFF.js.map
//# sourceMappingURL=chunk-RDMEGTFF.js.map